import { createUnleash } from 'shared/unleash/hook';
import type { UnleashToggles } from '@/domain';

const { UnleashProvider, useUnleash } = createUnleash<UnleashToggles>();

export { UnleashProvider, useUnleash };
